import React from "react";
import "./Terms_Conditions.css";

const Terms_Conditions = () => {
  return (
    <section className="Terms_Conditions">
      <div className="container">
        <h5 className="Terms_Conditions_title">
          {" "}
          Terms & <span>Conditions</span>{" "}
        </h5>

        <p className="term_text">
          By participating in this quiz, you agree to the following terms and
          conditions:
        </p>

        <p className="term_text">
          <strong>1.</strong>The quiz is intended for skill evaluation purposes
          only.
        </p>
        <p className="term_text">
          <strong>2.</strong> All answers must be submitted within the given
          time limit.
        </p>

        <p className="term_text">
          <strong>3.</strong>
          Results are generated automatically based on your responses.
        </p>

        <p className="term_text">
          <strong>4.</strong>
          Any attempt to manipulate, copy, or misuse the system may lead to
          disqualification.
        </p>

        <p className="term_text">
          <strong>5.</strong>
          Personal information submitted will be used only for communication and
          learning-related purposes.
        </p>

        <p className="term_text">
          <strong>6.</strong>
          Quiz results do not guarantee job placement but may be used to
          recommend suitable programs.
        </p>

        <p className="term_text">
          <strong>7.</strong>
          The organization reserves the right to modify quiz content or terms at
          any time without prior notice.
        </p>
      </div>
    </section>
  );
};

export default Terms_Conditions;
